import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import Avatar from '../../components/Avatar';
import Loader from '../../components/Loader';
import OutlineButton from '../../components/Button/OutlineButton.blue';
import Card from '../../components/Card';
import MessageDeliveryStatus from '../project-messages-user/MessageDeliveryStatus';

export default function Claim(props) {
  const { claim, onViewMessages } = props;

  const recipient = useConnect('user.byId', {
    id: claim.data.userId
  });

  const offer = useConnect('offer.byId', {
    id: claim.data.offerId
  });

  const creator = useConnect('user.byId', {
    id: claim.data.creatorId
  });

  if (
    recipient.state === PayloadStates.FETCHING ||
    offer.state === PayloadStates.FETCHING ||
    creator.state === PayloadStates.FETCHING
  ) {
    return (
      <Card>
        <Loader />
      </Card>
    );
  }

  const isStewardGenerated = (
    creator.id !== offer.data.creatorId &&
    claim.data.userId !== claim.data.creatorId
  );

  return (
    <Card>
      {isStewardGenerated && (
        <div className="px-4 py-1 bg-cs-orange-100">
          <span className="text-sm text-cs-gray-500">
            Connection made by {creator.data.firstName} {creator.data.lastName} (Steward)
          </span>
        </div>
      )}
      <div className="flex flex-col sm:flex-row p-4 gap-4">
        <div className="flex flex-1 items-center space-x-4">
          <Avatar size={12} src={recipient.data.avatarUrl}/>
          <div className="flex flex-col">
            <div className="text-lg font-semibold text-cs-gray-900">
              {recipient.data.firstName} {recipient.data.lastName}
            </div>
            {/*<div className="text-sm text-cs-gray-500">*/}
            {/*  {DateTime.fromISO(claim.data.createdAt).toRelative()} • <span className="text-cs-orange-500 font-medium">{claim.data.response === 'Connect' ? 'Connected' : claim.data.response}</span>*/}
            {/*</div>*/}
            <div className="text-sm text-cs-gray-500 space-x-1">
              <span>{DateTime.fromISO(claim.data.createdAt).toRelative()}</span>
              <span>·</span>
              <span className="text-cs-orange-500 font-medium">{claim.data.response === 'Connect' ? 'Connected' : claim.data.response}</span>
              {claim.data.response === 'Pending' && (
                claim.data.sendgridMessageId ||
                claim.data.postmarkMessageId
              ) && (
                <>
                  <span>·</span>
                  <MessageDeliveryStatus
                    className="text-cs-gray-500"
                    message={claim}
                  />
                </>
              )}
              {claim.data.response === 'Decline' && (
                <>
                  {/*<span>·</span>*/}
                  {/*<UserOrganization user={recipient}/>*/}
                  <span>·</span>
                  <span>{claim.data.responseMessage}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="flex space-x-4">
          <div className="flex items-center">
            {onViewMessages ? (
              <OutlineButton
                label={claim.data.response === 'Pending' ? 'Send followup' : 'Send message'}
                onClick={() => onViewMessages(recipient)}
              />
            ) : (
              <Link
                to={`/offer/${claim.data.offerId}/messages/${recipient.id}`}
                className="text-cs-blue-500 border border-cs-blue-500 py-2 px-3 rounded-lg hover:bg-cs-blue-100"
              >
                Send message
              </Link>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
